import { render, staticRenderFns } from "./VAdminAppMain.vue?vue&type=template&id=5a02fbc6&scoped=true"
import script from "./VAdminAppMain.vue?vue&type=script&lang=js"
export * from "./VAdminAppMain.vue?vue&type=script&lang=js"
import style0 from "./VAdminAppMain.vue?vue&type=style&index=0&id=5a02fbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a02fbc6",
  null
  
)

export default component.exports